import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useProjectCreateForm } from './hooks';

export const ProjectCreateScreen = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const {
        isSaving,
        isLoadingCustomers,
        error,
        customers,
        form,
        handleInputChange,
        handleSubmit,
        handleCancel,
    } = useProjectCreateForm({
        token,
        navigate,
    });

    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="card card__no-border">
                    <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="fw-bold mb-0">Nuevo proyecto</h5>
                            <button type="button" className="btn btn-light-brand" onClick={handleCancel}>
                                Volver
                            </button>
                        </div>

                        {error && (
                            <div className="alert alert-danger py-2" role="alert">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="project-customer">Cliente</label>
                                    <select
                                        id="project-customer"
                                        name="customer"
                                        className="form-select form-select-sm"
                                        value={form.customer}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isLoadingCustomers}
                                    >
                                        {customers.length === 0 && <option value="">Sin clientes disponibles</option>}
                                        {customers.map((customer) => (
                                            <option key={customer._id} value={customer._id}>
                                                {`${customer.code || 'SIN-COD'} - ${customer.name || 'Sin nombre'}`}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="project-name">Nombre del proyecto</label>
                                    <input
                                        id="project-name"
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        value={form.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label" htmlFor="project-status">Estatus</label>
                                    <select
                                        id="project-status"
                                        name="status"
                                        className="form-select form-select-sm"
                                        value={form.status}
                                        onChange={handleInputChange}
                                    >
                                        <option value="ACTIVE">Activo</option>
                                        <option value="SUSPENDED">Suspendido</option>
                                        <option value="INACTIVE">Inactivo</option>
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label" htmlFor="project-start-date">Fecha inicio</label>
                                    <input
                                        id="project-start-date"
                                        name="startDate"
                                        type="date"
                                        className="form-control"
                                        value={form.startDate}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label" htmlFor="project-end-date">Fecha fin</label>
                                    <input
                                        id="project-end-date"
                                        name="endDate"
                                        type="date"
                                        className="form-control"
                                        value={form.endDate}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-light-brand"
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                >
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={isSaving || isLoadingCustomers || !form.customer}>
                                    {isSaving ? 'Guardando...' : 'Crear proyecto'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
